import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { authedAtTimestampAtom } from '../../../auth/state';
import { useGetTelehealthSessionInfo } from '../../../hooks';
import { useVideoPlatform } from '../../../hooks/useVideoPlatform';
import { useTrackEvent } from '../../../segment/segment';
import { EventTypeEnum } from '../../../segment/types';
import { admissionTimeAtom } from './state';

export function useAdmissionTrackingEvents() {
  const { userViewed, userClicked } = useTrackEvent();
  const { patientShortId, providerShortId } = useParams<{
    patientShortId: string;
    providerShortId: string;
  }>();
  const { data } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const appointmentShortId = data?.telehealthSessionInfo?.appointment?.shortId;
  const videoPlatform = useVideoPlatform();
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);
  const admissionTime = useAtomValue(admissionTimeAtom);

  return useMemo(() => {
    const payload = {
      patientShortId: patientShortId ?? '',
      providerShortId: providerShortId ?? '',
      appointmentShortId: appointmentShortId ?? '',
      source: videoPlatform ?? '',
      admissionTime,
    };
    return {
      trackAdmissionPromptViewed: () => {
        userViewed(EventTypeEnum.ADMISSION_PROMPT_VIEWED, payload);
      },
      trackJoinSessionClicked: () => {
        userClicked(EventTypeEnum.JOIN_SESSION_CLICKED, {
          ...payload,
          isClientUserAuthenticated: !!authedAtTimestamp,
        });
      },
      trackAdmissionPromptDismissed: () => {
        userClicked(EventTypeEnum.ADMISSION_PROMPT_DISMISSED, payload);
      },
    };
  }, [
    patientShortId,
    providerShortId,
    appointmentShortId,
    videoPlatform,
    userViewed,
    userClicked,
    authedAtTimestamp,
    admissionTime,
  ]);
}
